import React from 'react'

const SubmitButton = props => {
    return(
			<button type="submit" ref={props.ref}>Submit</button>
    )
}

export default SubmitButton;